/*********** Routes for applications **************/

import React from 'react'
import { Switch } from 'react-router-dom'
import { privateLayout, LPMLayout, publicLayout, faqLayout } from '../components/Layouts'

import AppRoute from './AppRoute'
import { Auth } from '../auth'
import { public_type, private_type, app_type } from '../utilities/constants'
import LoginPage from '../containers/login/login'
import Users from '../containers/user/user'
import Location from '../containers/merchant/locations'
import Items from '../containers/merchant/items'
import Dashboard from '../containers/dashboard/dashboard'
import Merchants from '../containers/merchant/merchant'
import FeaturedMerchants from '../containers/featuredMerchant/featuredMerchant'
import Empty from '../containers/empty'
import PrivacyPolicy from '../containers/webviews/privacyPolicy'
import TermsAndCondition from '../containers/webviews/termsAndConditions'
import LicenseAgreement from '../containers/webviews/licenseAgreement'
import FAQ from '../containers/webviews/faq'
import ForgotPassword from '../containers/forgotPassword/index'
import OtpTimer from '../containers/forgotPassword/otpTimer'
import ChangePassword from '../containers/forgotPassword/changePassword'
import Settings from '../containers/settings/index'
import NotFound from '../components/NoFound'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import appLogin from '../containers/webviews/appLogin'
import Feedback from '../containers/feedback'
import Redeem from '../containers/redeem'

const Routers = (store) => {
    const user = useSelector((state) => state.user)

    return (
        <Switch>
            <AppRoute
                exact={true}
                path="/"
                component={LoginPage}
                requireAuth={Auth}
                layout={LPMLayout}
                store={store}
                type={public_type}
            />
            <AppRoute
                exact={true}
                path="/login"
                component={LoginPage}
                requireAuth={Auth}
                layout={LPMLayout}
                store={store}
                type={public_type}
            />

            <AppRoute
                exact={true}
                path="/dashboard"
                component={Dashboard}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                type={private_type}
            />

            <AppRoute
                exact={true}
                path="/app/privacyPolicy"
                component={PrivacyPolicy}
                requireAuth={Auth}
                layout={faqLayout}
                store={store}
                type={app_type}
            />

            <AppRoute
                exact={true}
                path="/app/termsAndCondition"
                component={TermsAndCondition}
                requireAuth={Auth}
                layout={faqLayout}
                store={store}
                type={app_type}
            />

            <AppRoute
                exact={true}
                path="/app/licenseAgreement"
                component={LicenseAgreement}
                requireAuth={Auth}
                layout={faqLayout}
                store={store}
                type={app_type}
            />

            <AppRoute
                exact={true}
                path="/app/faqs"
                component={FAQ}
                requireAuth={Auth}
                layout={faqLayout}
                store={store}
                type={app_type}
            />
            <AppRoute
                exact={true}
                path="/app/login"
                component={appLogin}
                requireAuth={Auth}
                layout={faqLayout}
                store={store}
                type={app_type}
            />
            <AppRoute
                exact={true}
                path="/location"
                component={Location}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                type={private_type}
            />
            <AppRoute
                exact={true}
                path="/items"
                component={Items}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                type={private_type}
            />

            <AppRoute
                exact={true}
                path="/users"
                component={Users}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                type={private_type}
            />
            <AppRoute
                exact={true}
                path="/merchants"
                component={Merchants}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                type={private_type}
            />
            <AppRoute
                exact={true}
                path="/dashboard1"
                component={Empty}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                type={private_type}
            />
            <AppRoute
                exact={true}
                path="/forgotPassword"
                component={ForgotPassword}
                requireAuth={Auth}
                layout={publicLayout}
                store={store}
                type={public_type}
            />
            <AppRoute
                exact={true}
                path="/otpTimer"
                component={OtpTimer}
                requireAuth={Auth}
                user={user}
                layout={publicLayout}
                store={store}
                type={public_type}
            />
            <AppRoute
                exact={true}
                path="/changePassword"
                component={ChangePassword}
                requireAuth={Auth}
                user={user}
                layout={publicLayout}
                store={store}
                type={public_type}
            />
            <AppRoute
                exact={true}
                path="/merchantItems"
                component={Items}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                type={private_type}
            />

            <AppRoute
                exact={true}
                path="/settings"
                component={Settings}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                user={user}
                type={private_type}
            />
            <AppRoute
                exact={true}
                path="/feedbacks"
                component={Feedback}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                user={user}
                type={private_type}
            />
            <AppRoute
                exact={true}
                path="/redemption"
                component={Redeem}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                user={user}
                type={private_type}
            />

            <AppRoute
                exact={true}
                path="/featuredMerchant"
                component={FeaturedMerchants}
                requireAuth={Auth}
                layout={privateLayout}
                store={store}
                user={user}
                type={app_type}
            />

            <AppRoute
                exact
                path="*"
                component={NotFound}
                requireAuth={Auth}
                layout={publicLayout}
                store={store}
                type={public_type}
            />
        </Switch>
    )
}

export default Routers
